import React from 'react';
import MenuItem from 'app/shared/layout/menus/menu-item';
import { DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink as Link } from 'react-router-dom';
import { Translate, translate } from 'react-jhipster';
import { NavDropdown } from './menu-components';

const accountMenuItemsAuthenticated = (
  <>
    {/* <MenuItem icon="wrench" to="/account/settings">
      <Translate contentKey="global.menu.account.settings">Settings</Translate>
    </MenuItem>
    <MenuItem icon="clock" to="/account/password">
      <Translate contentKey="global.menu.account.password">Password</Translate>
    </MenuItem> */}
    <MenuItem icon="user" to="/admin/info">
      {/* <Translate contentKey="global.menu.account.logout">Sign out</Translate> */}
      Thông tin tài khoản
    </MenuItem>
    <MenuItem icon="sign-out-alt" to="/logout">
      <Translate contentKey="global.menu.account.logout">Sign out</Translate>
    </MenuItem>
  </>
);

const accountMenuItems = (
  <>
    <MenuItem id="login-item" icon="sign-in-alt" to="/login">
      <Translate contentKey="global.menu.account.login">Sign in</Translate>
    </MenuItem>
    <MenuItem icon="sign-in-alt" to="/register">
      <Translate contentKey="global.menu.account.register">Register</Translate>
    </MenuItem>
    <MenuItem icon="sign-in-alt" to="/token/register">
      <Translate contentKey="global.menu.account.register.token">Register Token</Translate>
    </MenuItem>
    <MenuItem icon="sign-in-alt" to="/userprofile">
      Test form
    </MenuItem>
  </>
);

export const AccountMenu = ({ isAuthenticated = false }) => (
  <NavDropdown icon="user" name={translate('global.menu.account.main')} id="account-menu">
    {isAuthenticated ? accountMenuItemsAuthenticated : accountMenuItems}
  </NavDropdown>
);

export default AccountMenu;
